<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4>Detalle Envío Aduanas</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpCodigo">Id Solicitud</label>
                                <input formControlName="IdSolicitud" numbersOnly name="IdSolicitud" title=""
                                       class="form-control" id="inpNombre" type="text" value="" maxlength="9" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaInicioCompleta">Fecha Inicio</label>
                                <input formControlName="FechaInicioCompleta" name="FechaInicioCompleta" title=""
                                       class="form-control" id="inpFechaInicioCompleta" type="text" value="" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFechaCompleta">Fecha Envío</label>
                                <input formControlName="FechaCompleta" name="FechaCompleta" title=""
                                       class="form-control" id="inpFechaCompleta" type="text" value="" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpDuracionms">Duración (ms)</label>
                                <input formControlName="Duracionms" numbersOnly name="Duracionms" title="" 
                                       class="form-control" id="inpDuracionms" type="number" value=""  readonly>
                            </div>


                        </div>

                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpCodigoSolicitud">Código Solicitud</label>
                                <input formControlName="CodigoSolicitud" name="CodigoSolicitud" title=""
                                       class="form-control" id="inpCodigoSolicitud" type="text" value="" readonly>
                            </div>


                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpCodigoTaric">Código Taric</label>
                                <input formControlName="CodigoTaric" name="CodigoTaric" title=""
                                       class="form-control" id="inpCodigoTaric" type="text" value="" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpNrc">NRC</label>
                                <input formControlName="Nrc" name="Nrc" title=""
                                       class="form-control" id="inpNrc" type="text" value="" readonly>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpEstadoEnvioTraces">Estado Envío</label>
                                <input formControlName="EstadoEnvioAduanas" name="EstadoEnvioAduanas" title=""
                                       class="form-control" id="inpEstadoEnvioAduanas" type="text" value="" readonly>
                            </div>

                        </div>

                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpRespuesta">Respuesta</label>
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button name="btnCopiarRespuesta" class="btn btn-list btn-secondary" type="button" title="Copiar"
                                                (click)="onCopiarRespuesta(respuesta)">
                                            <i class="fa fa-copy"></i>
                                        </button>&nbsp;
                                    </span>
                                    <input readonly formControlName="Respuesta" #respuesta
                                           class="form-control" id="inpRespuesta" type="text" value="">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpDescripcionError">Error</label>
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button name="btnCopiarError" class="btn btn-list btn-secondary" type="button" title="Copiar"
                                                (click)="onCopiarError(descripcionerror)">
                                            <i class="fa fa-copy"></i>
                                        </button>&nbsp;
                                    </span>
                                    <input formControlName="DescripcionError" name="DescripcionError" title="" #descripcionerror
                                           class="form-control" id="inpDescripcionError" type="text" value="" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
